const GIFT_PROMO_ACTIVE = false;
if (!GIFT_PROMO_ACTIVE) return;


(() => {
  // =========================
  // CONFIG
  // =========================
  const GIFT_MIN_SUBTOTAL = 15000; // $150.00 in cents
  const GIFT_TITLE = "Free OG Tee";
  const GIFT_IMAGE_URL =
    "https://cdn.shopify.com/s/files/1/0721/6558/9295/files/6_769f3f0f-c356-42a0-8608-ab77329cf57a.png?v=1771528439";

  // IMPORTANT:
  // Put your actual variant IDs here (numbers).
  // If you already had these working before, paste your existing IDs in.
  const GIFT_VARIANTS = {
    S: 11111111111111,
    M: 22222222222222,
    L: 33333333333333,
    XL: 44444444444444,
    XXL: 55555555555555,
  };

  // =========================
  // HELPERS
  // =========================
  const money = (cents) => `$${(cents / 100).toFixed(2)}`;

  async function getCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    return res.json();
  }

  async function addGift(variantId) {
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    });
  }

  async function removeGiftByTitle(cart) {
    const updates = {};
    cart.items.forEach((item) => {
      if ((item.product_title || "").trim() === GIFT_TITLE) {
        updates[item.key] = 0;
      }
    });

    if (Object.keys(updates).length === 0) return;

    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ updates }),
    });
  }

  function hasGift(cart) {
    return cart.items.some((i) => (i.product_title || "").trim() === GIFT_TITLE);
  }

  function eligible(cart) {
    // If you want subtotal before discounts, Shopify cart.js provides items_subtotal_price.
    // total_price includes discounts/shipping not applied yet etc.
    return (cart.items_subtotal_price || 0) >= GIFT_MIN_SUBTOTAL;
  }

  function getCheckoutNode() {
    // Try common cart drawer checkout selectors (Paolo Alto varies)
    return (
      document.querySelector('button[name="checkout"]') ||
      document.querySelector('button[type="submit"][name="checkout"]') ||
      document.querySelector('a[href*="/checkout"]') ||
      document.querySelector('[data-checkout-button]') ||
      null
    );
  }

  function ensureGiftUIInserted(checkoutNode) {
    let wrap = document.getElementById("gwp-free-tee-wrap");
    if (wrap) return wrap;

    wrap = document.createElement("div");
    wrap.id = "gwp-free-tee-wrap";
    wrap.style.borderTop = "1px solid #e5e5e5";
    wrap.style.paddingTop = "12px";
    wrap.style.marginTop = "12px";

    wrap.innerHTML = `
      <div style="display:flex; gap:12px; align-items:center; margin-bottom:14px;">
        <img
          src="${GIFT_IMAGE_URL}"
          alt="${GIFT_TITLE}"
          style="width:75px;height:auto;border-radius:10px;border:1px solid #eee;"
        />
        <div>
          <div style="font-weight:600; font-size:14px; margin-bottom:4px;">
            ${GIFT_TITLE}
            <span style="background:#111;color:#fff;font-size:11px;padding:2px 6px;border-radius:6px;margin-left:6px;">FREE</span>
          </div>
          <div style="font-size:13px; opacity:.7;">${money(3800)} value · Unlocked at ${money(GIFT_MIN_SUBTOTAL)}+</div>
        </div>
      </div>

      <div style="font-size:13px; margin-bottom:8px;">
        Select your size to continue:
      </div>

      <select id="gwp-free-tee-select" style="width:100%; padding:10px; border:1px solid #ddd; border-radius:10px;">
        <option value="">Select size</option>
        <option value="${GIFT_VARIANTS.S}">Small</option>
        <option value="${GIFT_VARIANTS.M}">Medium</option>
        <option value="${GIFT_VARIANTS.L}">Large</option>
        <option value="${GIFT_VARIANTS.XL}">XL</option>
        <option value="${GIFT_VARIANTS.XXL}">XXL</option>
      </select>

      <div id="gwp-free-tee-msg" style="color:#b00020; font-size:13px; margin-top:8px; display:none;">
        Please select a size to continue to checkout.
      </div>
    `;

    // Insert directly before checkout button/link
    checkoutNode.parentElement.insertBefore(wrap, checkoutNode);

    const select = wrap.querySelector("#gwp-free-tee-select");
    const msg = wrap.querySelector("#gwp-free-tee-msg");

    select.addEventListener("change", async () => {
      msg.style.display = "none";
      const variantId = Number(select.value || 0);
      if (!variantId) return;

      const cart = await getCart();

      // If gift already in cart, do nothing
      if (hasGift(cart)) return;

      await addGift(variantId);

      // Reload so cart UI updates
      window.location.reload();
    });

    return wrap;
  }

  function setCheckoutEnabled(checkoutNode, enabled) {
    // Buttons
    if (checkoutNode.tagName === "BUTTON") {
      checkoutNode.disabled = !enabled;
      checkoutNode.style.opacity = enabled ? "" : "0.5";
      checkoutNode.style.pointerEvents = enabled ? "" : "none";
      return;
    }
    // Links
    checkoutNode.style.pointerEvents = enabled ? "" : "none";
    checkoutNode.style.opacity = enabled ? "" : "0.5";
  }

  // =========================
  // MAIN SYNC LOOP
  // =========================
  async function sync() {
    const checkoutNode = getCheckoutNode();
    if (!checkoutNode) return;

    const cart = await getCart();
    const isEligible = eligible(cart);
    const giftAlready = hasGift(cart);

    if (isEligible && !giftAlready) {
      // Require size selection before checkout
      ensureGiftUIInserted(checkoutNode);
      setCheckoutEnabled(checkoutNode, false);
      return;
    }

    // Not eligible OR already has gift -> cleanup UI + enable checkout
    const wrap = document.getElementById("gwp-free-tee-wrap");
    if (wrap) wrap.remove();

    setCheckoutEnabled(checkoutNode, true);

    // If not eligible but gift exists, remove it
    if (!isEligible && giftAlready) {
      await removeGiftByTitle(cart);
      window.location.reload();
    }
  }

  // Run on load + watch for cart drawer re-render
  document.addEventListener("DOMContentLoaded", () => {
    sync();
    const obs = new MutationObserver(() => sync());
    obs.observe(document.documentElement, { childList: true, subtree: true });
  });
})();

